import {Styles} from 'react-floater';

import {envs} from './envs';

export const clientRoutes = {
  Main: '/',
  AuthUser: '/auth/user',
  ClickerGame: '/clicker-game',
  Calculator: '/calculator',
  Leagues: '/calculator/leagues',
  InvitePage: '/invite/:refId/*',
  Faq: '/faq',
  Results: '/results',
  //test
  TestEnergyBattery: '/energy-battery',
  TestLinks: '/test-links',
} as const;

const queriesSubRoute = envs.APP_PROJECT_API_USE_CQRS ? '/queries' : '';
const commandsSubRoute = envs.APP_PROJECT_API_USE_CQRS ? '/commands' : '';

export const apiRoutes = {
  auth: {
    login: `${commandsSubRoute}/v1/auth/login`,
    logout: `${commandsSubRoute}/v1/auth/logout`,
  },
  user: {
    info: `${queriesSubRoute}/v1/user/info`,
    tasks: `${queriesSubRoute}/v1/user/tasks`,
    tasksInstantReward: `${commandsSubRoute}/v1/user/tasks/instant-reward`,
    tasksSeen: `${commandsSubRoute}/v1/user/tasks/seen`,
    tasksLinkClick: `${commandsSubRoute}/v1/user/tasks/link-click`,
    gameSync: `${commandsSubRoute}/v1/user/game/sync`,
    gameStatus: `${queriesSubRoute}/v1/user/game/status`,
    leaderBoard: `${queriesSubRoute}/v1/user/game/leaderboard`,
    league: `${queriesSubRoute}/v1/user/game/league`,
    leagueInit: `${commandsSubRoute}/v1/user/game/league`,
    improvements: `${queriesSubRoute}/v1/user/game/improvements`,
    getDailyRewards: `${queriesSubRoute}/v1/user/daily-rewards`,
    claimDailyRewards: `${commandsSubRoute}/v1/user/daily-rewards/claim`,
    dailyGameConfig: `${queriesSubRoute}/v1/user/daily-game/config`,
    checkDailyGameCipher: `${commandsSubRoute}/v1/user/daily-game`,
    gifts: `${queriesSubRoute}/v1/user/gifts`,
    giftsSeen: `${commandsSubRoute}/v1/user/gifts/seen`,
    onboarding: `${commandsSubRoute}/v1/user/onboarding`,
    claimOnboardingGift: `${commandsSubRoute}/v1/user/onboarding/claim-gift`,
    settings: `${commandsSubRoute}/v1/user/settings`,
    statistics: `${queriesSubRoute}/v1/user/statistics`,
  },
  calculator: {
    result: `/private/v1/calculator/game`,
  },
} as const;

export enum HTMLElementId {
  Form = 'form',
  ClickerGamePageContainer = 'clicker-game-page-container',
  ImprovementsMapStage = 'improvements-map-stage',
  ClickerGamePoints = 'clicker-game-points',
  ClickerGamePointsCrystal = 'clicker-game-points-crystal',
  ClickerGameRecharge = 'clicker-game-recharge',
  ModalDetailContent = 'modal-detail-content',
  PageModalClickerContainer = 'page-modal-container',
  RewardsAnimationCrystal = 'rewards-animation-crystal',
  RewardsAnimationRecharge = 'rewards-animation-recharge',
  RewardsBadge = 'rewards-badge',
  RewardsGift = 'rewards-gift',
  CipherResultCrystal = 'cipher-result-crystal',
  AnimationCrystal = 'animation-crystal',
  HeaderGiftsIcon = 'header-gifts-icon',
  HeaderNoticeBadge = 'header-notice-badge',
  GameCanvas = 'game-canvas',
  DailyGameRadar = 'daily-game-radar',
  RechargeWithTasksTarget = 'recharge-with-tasks',
  HTMLKotletka = 'html-kotletka',
  HTMLKotletkaTooltipTarget = 'html-kotletka-tooltip-target',
  RootLayout = 'root-layout',
  ResultsBottomBarStatisticsButton = 'results-bottom-bar-statistics-button',
  LeaderBoardPlayerItem = 'leader-board-player-item',
  WinnersPage = 'winners-page',
}

export const REF_ID = 'refId';
export const AUTH_TOKEN = 'authToken';
export const userIdKey = 'userId';

export enum LSKeys {
  CustomSSOToken = 'customSSOToken',
  PerformanceModeEnabled = 'performanceModeEnabled',
  WasSeenWinnersModal = 'wasSeenWinnersModal',
}

export const SEND_DEBOUNCE_TIME = 3000;

export enum SvgFiltersIdsType {
  FilterBatteryEnergyFlashIcon = 'filter_battery_energy_flash_icon',
  FilterBatteryEnergyIcon = 'filter_battery_energy_icon',
  FilterCheckboxActiveIcon = 'filter_checkbox_active_icon',
  FilterCheckboxDoneIcon = 'filter_checkbox_done_icon',
  FilterEnergyModalCloseIcon = 'filter_energy_modal_close_icon',
  FilterFaqIcon = 'filter_faq_icon',
  FilterGiftsIcon = 'filter_gifts_icon',
  FilterImprovementsIcon = 'filter_improvements_icon',
  FilterNoticeIcon = 'filter_notice_icon',
  FilterSettingsIcon = 'filter_settings_icon',
  FilterTasksIcon = 'filter_tasks_icon',
  FilterProjectLogoIcon = 'filter_project_logo_icon',
  FilterInfoIcon = 'filter_info_icon',
  FilterUpgradeResultIcon = 'filter_upgrade_result_icon',
  RadialGradientImprovementLockIcon = 'radial_gradient_improvement_lock_icon',
  RadialGradientImprovementUnlockIcon = 'radial_gradient_improvement_unlock_icon',
  RadialGradientEnergyModalCloseIcon = 'radial_gradient_energy_modal_close_icon',
  LinearGradientCheckboxActiveIcon = 'linear_gradient_checkbox_active_icon',
  ClipPathCheckboxActiveIcon = 'clip_path_checkbox_active_icon',
  ClipPathCheckboxDoneIcon = 'clip_path_checkbox_done_icon',
  ClipPathMultiTapIcon = 'clip_path_multi_tap_icon',
  SearchIconFilter = 'search-icon-filter',
  RadarIconCircle1 = 'radar-icon-filter-circle-1',
  RadarIconCircle2 = 'radar-icon-filter-circle-2',
  RadarIconCircle3 = 'radar-icon-filter-circle-3',
  RadarIconCircle4 = 'radar-icon-filter-circle-4',
  RadarIconFilterRadial1 = 'radar-icon-filter-radial-1',
  RadarIconFilterRadial2 = 'radar-icon-filter-radial-2',
  RadarHoverIconFilter1 = 'radar-hover-icon-filter-1',
  RadarHoverIconFilter2 = 'radar-hover-icon-filter-2',
  RadarHoverIconFilter3 = 'radar-hover-icon-filter-3',
  RadarHoverIconRadial1 = 'radar-hover-icon-radial-1',
  RadarHoverIconRadial2 = 'radar-hover-icon-radial-2',
  RadarDisabledIconFilter = 'radar-disabled-icon-filter',
  RadarDisabledIconRadial = 'radar-disabled-icon-radial-1',
  SputnikIconFilter = 'sputnik-icon-filter',
  SpaceshipIconFilter = 'spaceship-icon-filter',
}

export const DAILY_STREAK_A_B_TEST_TOGGLE = 'ded_ps_specials/invest_24_test';

export enum LocalStorageKeys {
  GameOperations = 'GameOperations',
  AxiosTimeoutValue = 'axios_timeout_value',
}

export const FLOATER_STYLES: Partial<Styles> = {
  floater: {
    filter: 'none',
  },
  options: {
    zIndex: 2000,
  },
  arrow: {
    spread: 14,
    length: 10,
    color: 'var(--primary-yellow-color)',
    boxShadow: '0px 0px 17px 0px rgba(255, 221, 45, 0.6)',
  },
};

export const TOOLTIP_VISIBLE_TIME = 8000;

export const SCROLL_TO = 'scroll_to_';
